import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  clients: [],
  permanentLicenses: [],
  temporaryLicenses: [],
  offlineLicenses: [],
  productReleases: [],
  accounts: [],
  trialRejectedDevices: [],
  webViewerServers: [],
  webViewerLicenses: [],
  bannedDevices: [],
  banHistory: [],
};

const selectedItems = createSlice({
  name: 'selectedItems',
  initialState,
  reducers: {
    setObjectSelection: (state, action) => {
      const { objectName, selectedItems } = action.payload;
      state[objectName] = selectedItems;
    },
    clearObjectSelection: (state, action) => {
      const { objectName } = action.payload;
      state[objectName] = [];
    }
  },
});

const { reducer, actions } = selectedItems;

const { setObjectSelection, clearObjectSelection } = actions;

export const setSelection = (selectedItems, objectName) => (dispatch) => {
  return new Promise((resolve) => {
    dispatch(setObjectSelection({ selectedItems, objectName }));
    resolve();
  });
};

export const clearSelection = (objectName) => (dispatch) => {
  dispatch(clearObjectSelection({ objectName }));
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/userConfigs/selectedItemsSlice.js